const cart = [];

const handleCart = (state = cart, action) => {

    const product = action.payload;

    console.log({ action_type : action.type});
    console.log({ product : product });
 
    switch (action.type) {
        case "ADDITEM":
            const exist = state.find((x) => x.id === product.id);
            if (exist) {
                return state.map((x) =>
                    x.id === product.id ? { ...x, qty: x.qty + 1 } : x
                );
            } else {
                const product = action.payload;
                return [
                    ...state,
                    {
                        ...product,
                        qty: 1,
                    },
                ];
            }
            break;

        case "DELETITEM":
            const delet = state.find((x) => x.id === product.id);
            if (delet.qty === 1) {
                return state.filter((x) => x.id !== delet.id);
            } else {
                return state.map((x) =>
                    x.id === product.id ? { ...x, qty: x.qty - 1 } : x
                );
            }
            break;
            
        default:
            return state;
            break;
    }
};

export default handleCart;
